/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListGrantsSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ListGrantsRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListGrantsSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListGrantsSecurity$outboundSchema: z.ZodMiniType<
  ListGrantsSecurity$Outbound,
  ListGrantsSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listGrantsSecurityToJSON(
  listGrantsSecurity: ListGrantsSecurity,
): string {
  return JSON.stringify(
    ListGrantsSecurity$outboundSchema.parse(listGrantsSecurity),
  );
}

/** @internal */
export type ListGrantsRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListGrantsRequest$outboundSchema: z.ZodMiniType<
  ListGrantsRequest$Outbound,
  ListGrantsRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
    });
  }),
);

export function listGrantsRequestToJSON(
  listGrantsRequest: ListGrantsRequest,
): string {
  return JSON.stringify(
    ListGrantsRequest$outboundSchema.parse(listGrantsRequest),
  );
}
